import {SET_BAKGROUND, SET_COLOR, PROGRESS } from '../store'
import $ from 'jquery'

export default {
  methods: {
    completeLoad (background, color) {
      let self = this
      self.startProgress();
      self.imageLoad(background, function () {
        self.$store.commit(SET_BAKGROUND, { src: background, dir: 'fade' })
        self.$store.commit(SET_COLOR, color)
        self.stopProgress();
      })
    },

    imagesLoad (list) {
      for (let key in list) {
        this.imageLoad(list[key])
      }
    },

    changeBackground(src, dir, callback) {
      this.startProgress();
      this.imageLoad(src, (src) => {
        this.$store.commit(SET_BAKGROUND, { src: src, dir: dir })
        this.stopProgress();
        if (callback) {
          callback()
        }
      })
    },

    imageLoad(src, callback) {
      if (!src) { 
        if (callback) {
          callback(null)
        }
        return 
      }

      var img = new Image();

      img.onload = function() {
        if (callback) {
          callback(src)
        }
      }

      img.src = src;
    },

    startProgress() {
      this.$store.commit(PROGRESS, true)
    },

    stopProgress() {
      this.$store.commit(PROGRESS, false)
    },

    toTop() {
      $("html, body").animate({ scrollTop: 0 }, "slow")
    },

    fxLogo() {
      $('.logo').removeClass('only-img')
    },

    setBodyClasses(classes) {
      let body = $('body')
      body.removeClass();

      for (let i in classes) {
        body.addClass(classes[i])
      }
    }
  }
}
